$(document).ready(function () {

    if (Vendd && Vendd.Scripts && (typeof Vendd.Scripts.init === 'function')) {

        Vendd.Scripts.init();

        if (LhApp && LhApp.init && (typeof LhApp.init === 'function'))
            LhApp.init();
    }    
});